module.exports = __webpack_public_path__ + "media/images/switch-0d4b679c33c03739388a8b0ebb2bd372.png";